/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {DELETE_ORDER, GET_ORDER, GET_OBSERVACIONES, GET_ORDERS, INIT_REQUEST, GET_ORDER_PDF, INIT_ORDER_PDF, DOWNLOAD_ORDER_PDF, INIT_DOWNLOAD_ORDER_PDF, SEND_ORDER, SET_ORDER_FROM_ALLDATA, SWITCH_BILLTO_SELLTO} from '../actions'

const initialState = {
  data: [],
  total: 1,
  params: {},
  allData: [],
  order: undefined,
  orderPdf: '',
  orderNoPdf: '',
  processing: false,
  showFromHijos: false,
  observaciones: []
}


const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_REQUEST:
      return {
        ...state,
        processing: true
      }
    case GET_ORDERS:
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        processing: false
      }
    case GET_ORDER:
      return {
        ...state,
        order: action.order,
        processing: false
      }
    case GET_ORDER_PDF:
      return {
        ...state,
        orderPdf: action.orderPdf,
        orderNoPdf: action.documentNo
      }
    case GET_OBSERVACIONES:
      return {
        ...state,
        observaciones: action.data
      }
    case INIT_ORDER_PDF:
      return {
        ...state,
        orderPdf: '',
        orderNoPdf: ''
      }
    case DOWNLOAD_ORDER_PDF:
      return {
        ...state,
        orderPdf: action.orderPdf,
        orderNoPdf: action.orderNo,
        processing: false
      }
    case INIT_DOWNLOAD_ORDER_PDF:
      return {
        ...state,
        orderPdf: '',
        orderNoPdf: ''
      }
    case DELETE_ORDER:
      return {...state}
    case SEND_ORDER:
      return {
        ...state,
        processing: false
      }
    case SET_ORDER_FROM_ALLDATA:
      return {
        ...state,
        order: state.allData.find(order => order.documentNo === action.data)
      }
    case SWITCH_BILLTO_SELLTO:
      return {
        ...state,
        showFromHijos: !state.showFromHijos
      }
    default:
      return {...state}
  }
}
export default orderReducer
